import colleges from "./components/colleges";
import { createFilter } from "react-select";

export const UNIVERSITY_NOT_LISTED = "University Not Listed";
export const LEGACY_UNIVERSITY_NOT_LISTED = "-College Not Present";

const listedUniversityOptions = colleges.map((university) => ({
  value: university,
  label: university,
}));
const listedUniversityOptionsByName = new Map(
  listedUniversityOptions.map((option) => [option.value, option])
);
const universityNotListedOption = {
  value: UNIVERSITY_NOT_LISTED,
  label: UNIVERSITY_NOT_LISTED,
};

export const universityOptions = [
  ...listedUniversityOptions,
  universityNotListedOption,
];

const filterListedUniversity = createFilter();
export const filterUniversityOption = (option, input) =>
  option.value === UNIVERSITY_NOT_LISTED || filterListedUniversity(option, input);

export const getUniversitySelection = (university) => {
  if (!university) return null;

  return (
    listedUniversityOptionsByName.get(university) || universityNotListedOption
  );
};

export const isUniversityNotListed = (university) =>
  Boolean(university) && !listedUniversityOptionsByName.has(university);

export const getUnlistedUniversityName = (university) => {
  if (
    !university ||
    university === UNIVERSITY_NOT_LISTED ||
    university === LEGACY_UNIVERSITY_NOT_LISTED
  ) {
    return "";
  }

  return university;
};
